import { getCollection } from "store/domain/selectors";
import { orderBy } from "lodash";

export function getOrderedEvents(state, collectionName) {
  const events = getCollection(state, collectionName);
  return orderBy(events, ["created_at"], ["desc"]);
}
